import { createContext, FC, PropsWithChildren } from 'react';

import { DashboardGranularity } from '../../../../../__generated__/GQL';
import { RangeIntervalDate } from '../RangeIntervalPicker/utils';

export const IntervalContext = createContext<{
  interval: RangeIntervalDate;
  // Add to the context the granularity of the dashboard's data aggregation
  granularity: DashboardGranularity;
} | null>(null);

const IntervalContextProvider: FC<
  PropsWithChildren<{
    interval: RangeIntervalDate;
    granularity: DashboardGranularity;
  }>
> = ({ children, granularity, interval }) => {
  return (
    <IntervalContext.Provider
      value={{
        granularity: granularity || null,
        interval: interval || null,
      }}
    >
      {children}
    </IntervalContext.Provider>
  );
};

export default IntervalContextProvider;
